export default "__VITE_ASSET__BtmFllk2__"